var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { attrs: { id: "app" } }, [
    _vm._m(0),
    _c("div", { staticClass: "container" }, [
      _vm.$route.name != "PrivacyPolicy"
        ? _c("div", { staticClass: "title" }, [
            _vm._v(
              _vm._s(_vm.$t("global." + _vm.translationSection + ".title"))
            ),
          ])
        : _vm._e(),
      _c(
        "div",
        _vm._l(_vm.stepList, function (step, idx) {
          return _c(
            "div",
            {
              key: idx,
              staticClass: "stepperContainer",
              attrs: { id: step.htmlId },
            },
            [
              _c("div", { class: [step.cssClass, "step"] }, [
                idx != 0
                  ? _c(
                      "div",
                      {
                        class: [
                          "stepBevel",
                          {
                            stepActive:
                              step.cssClass == "stepComplete" ||
                              step.cssClass == "stepActive",
                            stepDisabled: step.cssClass == "stepDisabled",
                          },
                        ],
                      },
                      [
                        _c("div", { staticClass: "triangle" }),
                        _c("div", { staticClass: "triangle2" }),
                      ]
                    )
                  : _vm._e(),
                _c("span", { staticClass: "stepLabel" }, [
                  _vm._v(
                    _vm._s(_vm.$t("stepper.step_number")) +
                      " " +
                      _vm._s(idx + 1) +
                      ":"
                  ),
                ]),
                _c("span", {
                  staticClass: "stepNameLabel",
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("stepper." + step.label)),
                  },
                }),
              ]),
              _c("div", { class: [step.cssClass, "stepBevel"] }, [
                _c("div", { staticClass: "triangle" }),
                _c("div", { staticClass: "triangle2" }),
              ]),
            ]
          )
        }),
        0
      ),
    ]),
    _c(
      "div",
      { staticClass: "container", attrs: { id: "main-view" } },
      [_c("router-view")],
      1
    ),
    _c("footer", {
      attrs: { id: "footer" },
      domProps: {
        innerHTML: _vm._s(
          _vm.$t("global.footer_text", { Year: new Date().getFullYear() })
        ),
      },
    }),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "keyloop-global-header" }, [
      _c("div", { staticClass: "keyloop-global-header__toolbar" }, [
        _c("div", { staticClass: "keyloop-global-header__branding" }, [
          _c("div", { staticClass: "keyloop-global-header__logo" }),
          _c("div", { staticClass: "keyloop-global-header__divider" }),
          _c("div", { staticClass: "keyloop-global-header__title" }, [
            _c("span", [_vm._v("Social Integration Tool")]),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }